import {ReactableColumnDef} from '@deviceinsight/ng-ui-components';

import {AssetGroup} from '@deviceinsight/ng-ui-api-client';

import {Trans, useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';

import warning_icon from '../../assets/icon_warning_triangle.svg';
import ErrorInfoTable, {ValidationErrorTableItem} from './reactable/ErrorInfoTable';

import {DataProcessingDefinitionValidationError} from './types';

type Props = {
	currentDpdValidationErrors: Array<DataProcessingDefinitionValidationError>;
	kpiName: string;
	selectedAssetGroup: AssetGroup;
};

const columnDefs: Array<ReactableColumnDef<ValidationErrorTableItem>> = [
	{
		name: 'assetGroupName',
		label: 'Asset Group',
		sortable: true,
		render: (item) => <strong>{item.assetGroupName}</strong>
	},
	{
		name: 'assetName',
		label: 'Asset',
		sortable: true,
		render: (item) => item.assetName
	},
	{
		name: 'calculatedDPName',
		label: 'Already existing Datapoint Name',
		sortable: true,
		render: (item) => (
			<span>
				<img src={warning_icon} alt="warningIcon" /> {item.calculatedDPName}
			</span>
		)
	}
];

const MessageDetail = ({calculatedDPName}: {calculatedDPName: string}) => (
	<>
		<Trans i18nKey="assets.detail.dataProcessingDefinition.unShareableMessage.detail.1">Solution:</Trans>
		<p>
			<Trans i18nKey="assets.detail.dataProcessingDefinition.unShareableMessage.detail.2Alt">
				To make sharing possible, please rename the calculated datapoint{' '}
				{{
					calculatedDPName
				}}{' '}
				to a different name.
			</Trans>
		</p>
	</>
);

const UnShareableInformation = ({
	currentDpdValidationErrors,
	kpiName: calculatedDPName,
	selectedAssetGroup: {displayName, name}
}: Props) => {
	const {t} = useTranslation();
	const assetGroupName = displayName || name;
	const warningTitle = t('assets.detail.dataProcessingDefinition.unShareableMessage.title', {
		assetGroupName,
		calculatedDPName,
		defaultValue: `The calculated datapoint "{{calculatedDPName}}" can currently not be shared with the group "{{assetGroupName}}". Assets in this group already contains a datapoint name "{{calculatedDPName}}."`
	});
	return (
		<ErrorInfoTable
			currentDpdValidationErrors={currentDpdValidationErrors}
			kpiName={calculatedDPName}
			warningTitle={warningTitle}
			warningDetail={<MessageDetail calculatedDPName={calculatedDPName} />}
			assetGroupName={assetGroupName}
			columnDefs={columnDefs}
		/>
	);
};

export default UnShareableInformation;
